import axios from 'axios';
import { JWTService } from '@/shared/services/jwt';
import router from '@/router';

const getRepresentanteId = () =>{
    return window.localStorage.getItem('Representante')
}

const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_WEB_API,
    headers: {
        'Authorization': `Bearer ${JWTService.GetToken()}`,
        'Representante': `${getRepresentanteId()}`
    }
})

axiosInstance.interceptors.response.use((response)=>{
    if(response.data != null) {
        if(response.data.usuarioLogado == false) {
            JWTService.DestroyToken()
        }
    }
    return response
    
}, (erro) => {

    const gamaErro = {}
    gamaErro.data = erro.config.data
    gamaErro.url = erro.config.url
    gamaErro.mensagem = erro.message
    gamaErro.status = erro.response.status
    if(gamaErro.status == 401){
        router.push("/")
    }
    console.error(gamaErro)
})

export default axiosInstance
